export type reminder = {
    _id: string;
    userId: string;
    notes: string;
    appNotes: string;
    nome: string;
    cognome: string;
    email: string;
    done: boolean;
    expiresOn?: Date;
    blockAccess: boolean;
}
export const emptyReminder = (_email?: string, _userid?: string): reminder => ({
    _id: undefined,
    userId: _userid ?? '',
    email: _email ?? '',
    notes: '',
    appNotes: '',
    nome: '',
    cognome: '',
    done: false,
    blockAccess: true,
});